import { Inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

import { ApiService } from './api.service';
import { ApiUrl } from './constants';
import { RequestParams } from '@src/app/shared/types/common';
import { RoutesEnum } from '@src/app/enums';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ProductsMoreService {
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$: Observable<boolean> = this.isLoadingSubject.asObservable();

  constructor(
    @Inject(Router) private router: Router,
    private apiService: ApiService,
  ) {}

  setIsLoading(value: boolean): void {
    this.isLoadingSubject.next(value);
  }

  /**
   * @description Handling API call errors
   * @param {HttpErrorResponse} error
   */
  handleError(error: HttpErrorResponse): void {
    this.isLoadingSubject.next(false);

    if (
      error.error?.statusCode === 404 ||
      error.error?.status === 404 ||
      error?.status === 404
    ) {
      this.router.navigate(['/' + RoutesEnum.NOT_FOUND], {
        skipLocationChange: true,
      });
    } else if (error.error?.message) {
      console.error(error.error?.message);
    }
  }

  getCategories(params: RequestParams): Observable<any[]> {
    this.isLoadingSubject.next(true);

    return this.apiService.request({
      method: 'get',
      endpoint: ApiUrl.getProductsMoreCategories,
      params,
    });
  }

  getProductDetails(
    id: number,
    params: RequestParams,
    options?: { withLoading?: boolean },
  ): Observable<Record<string, any>> {
    if (options?.withLoading) {
      this.isLoadingSubject.next(true);
    }

    return this.apiService.request({
      method: 'get',
      endpoint: ApiUrl.getProductsDetails(id),
      params,
    });
  }

  getItemDetails(
    id: number,
    params: RequestParams,
    options: { withLoading?: boolean } = { withLoading: true },
  ): Observable<any[]> {
    if (options?.withLoading) {
      this.isLoadingSubject.next(true);
    }

    return this.apiService.request({
      method: 'get',
      endpoint: ApiUrl.getProductsMoreDetails(id),
      params,
    });
  }

  getSpecialOffer(
    id: number,
    params: RequestParams,
    options: { withLoading?: boolean } = { withLoading: true },
  ): Observable<any[]> {
    if (options?.withLoading) {
      this.isLoadingSubject.next(true);
    }

    return this.apiService.request({
      method: 'get',
      endpoint: ApiUrl.getProductsSpecialOffer(id),
      params,
    });
  }
}
